import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { APIResult, PaginatedApiResult } from '../../global/interfaces/api-result';
import { apiResult } from '../../global/operators/api-result';
import { StudyArea, StudyAreaCommentRequest } from '../interfaces/study-area';

@Injectable({ providedIn: 'root' })
export class ManagerApiService {
  apiBase: string = '/api/manage/';

  constructor(private httpClient: HttpClient) {}

  getStudyAreas(continuationToken?: string, pageSize?: number): Observable<PaginatedApiResult<StudyArea>> {
    let url: string = `${this.apiBase}studyArea?`;
    if(continuationToken) {
      url += `continuationToken=${continuationToken}`;
    }
    if(pageSize) {
      url += `&pageSize=${pageSize}`;
    }
    return this.httpClient.get<PaginatedApiResult<StudyArea>>(url);
  }

  getAllStudyAreas(): Observable<StudyArea[]> {
    return this.httpClient.get<any>(`${this.apiBase}allStudyAreas`)
      .pipe(map((r) => r.$values));
  }

  updatePaidStatus(body: any): Observable<void> {
    return this.httpClient.patch<void>(`${this.apiBase}/studyArea/status`, body);
  }

  updateStudyAreaComment(request: StudyAreaCommentRequest): Observable<void> {
    
    return this.httpClient.patch<void>(`${this.apiBase}studyArea/${request.studyAreaId}/comment`, request);
  }

  getEnabledFeatures(): Observable<string[]> {
    return this.httpClient
      .get<APIResult<any>>(`${this.apiBase}/features`)
      .pipe(apiResult())
      .pipe(map((r) => r.$values));
  }

  deleteStudyArea(studyAreaId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiBase}studyArea/${studyAreaId}`);
  }
}
